/** @file Base names of the document's animations (`walk@SE` → `walk`), each once, sorted. */
import { names } from '@pose2d/format/names';
import type { Doc } from '@pose2d/format/types';

/** The keys a mirrorFix `fix.animations` map may use. */
export function animationBases(doc: Doc): string[] {
  return [...new Set(Object.values(doc.animations).map((a) => names.splitAnimation(a.name).base))].sort();
}
